import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { ChevronIcon } from 'src/ui/assets/icons/arrow/ChevronIcon';
import { withConfig } from 'src/withConfig';

type SectionHeaderWrapperType = {
    isOpen: boolean;
    variant: DefaultComponentVariantType | null;
}
const setCollapseWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            cursor: default;
            text-transform: capitalize;
            @media ${theme.star.mediaQuery.tablet} {
                border-radius: ${theme.star.radius.medium} ${theme.star.radius.medium} 0 0;
                margin: 0 8px;
            }
            &::after {
                border-top: none;
            }
        `;
    }
    return css`
        cursor: pointer;
    `;
};

export const CollapseWrapper = withConfig(theme => styled('div', { label: 'CollapseWrapper' }) <SectionHeaderWrapperType>`
    ${({ variant }): SerializedStyles => setCollapseWrapper(variant, theme)}
    align-items: center;
    background: ${theme.star.collapse.section.bgColor};
    color: ${theme.star.collapse.section.txtColor};
    display: flex;
    flex-flow: row nowrap;
    gap: 8px;
    height: 40px;
    justify-content: start;
    padding: 8px;
    position: relative;
    &::after {
        border-top: 1px solid ${theme.star.collapse.section.borderColor};
        inset: auto 0 0;
        content: '';
        opacity: ${({ isOpen }):string => isOpen ? '0' : '1'};
        position: absolute;
        transition: opacity .2s ease;
        width: 100%;
    }
`);

export const ChevronWrapper = withConfig(theme => styled(ChevronIcon, { label: 'ChevronWrapper' })`
    fill: ${theme.star.collapse.section.bgColorSecondary};
    flex: 0 0 16px;
    width: 16px;
`);

interface SectionTitlePropsType {
    variant: DefaultComponentVariantType | null;
}

export const SectionTitle = withConfig(theme => styled('h2', { label: 'SectionTitle' })<SectionTitlePropsType>`
    flex: 1 1 auto;
    font-size: ${theme.star.fontSize.regular};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.4286;
    margin: 0;
    text-overflow: ellipsis;
    user-select: none;
    overflow: hidden;
    white-space: nowrap;
    text-transform: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'capitalize' : 'none'};
`);
